// client/src/components/CreateAccount.js

import React, { useState } from 'react';
import axiosInstance from '../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import AppBarHeader from './AppBarHeader'; // Import AppBarHeader

function CreateAccount() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({ username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // The handleInputChange function handles the input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  // The handleSubmit function handles form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the default form submit action
    try {
      // Fetch token from localStorage
      const token = localStorage.getItem('token');
      // Make a POST request to create a new user account
      await axiosInstance.post('/admin/users', userData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSuccess('Account created successfully');
      setTimeout(() => navigate('/admin'), 2000); // Redirect to Admin Dashboard after success
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error('Server Error:', error.response.data);
        setError(`Failed to create account: ${error.response.data.message || 'Unknown server error'}`);
      } else if (error.request) {
        // Request was made but no response received
        console.error('Network Error:', error.request);
        setError('Network error: No response from server');
      } else {
        // Something else happened
        console.error('Error:', error.message);
        setError('An unexpected error occurred');
      }
    }
  };

  return (
    <div>
      <AppBarHeader />
      <Box sx={{ maxWidth: 600, margin: '0 auto', padding: '20px', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Create New Account</Typography>
        <Button
          variant="outlined"
          onClick={() => navigate('/admin')}
          sx={{ mb: 2 }}
        >
          ← Back to Admin Dashboard
        </Button>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}
        {/* Form for creating a new account */}
        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Username"
              name="username"
              variant="outlined"
              value={userData.username}
              onChange={handleInputChange}
              required
            />
          </Box>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              variant="outlined"
              type="email"
              value={userData.email}
              onChange={handleInputChange}
              required
            />
          </Box>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Password"
              name="password"
              variant="outlined"
              type="password"
              value={userData.password}
              onChange={handleInputChange}
              required
            />
          </Box>
          <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
            Create Account
          </Button>
        </form>
      </Box>
    </div>
  );
}

export default CreateAccount;
